import emailjs from '@emailjs/browser';
import config from "../config/config";

export interface NewsletterSubscriptionData {
    email: string;
}

export const sendNewsletterSubscriptionEmail = async (
    data: NewsletterSubscriptionData
): Promise<boolean> => {
    try {
        // Initialize EmailJS with the public key
        emailjs.init(config.emailjs.publicKey);

        const templateParams = {
            email: data.email,
            submittedAt: new Date().toLocaleString('fr-FR'),
            name: data.email.split('@')[0],
            emailTo: config.contact.subscribeEmail

        };

        console.log('Sending newsletter email with params:', JSON.stringify(templateParams, null, 2));

        await emailjs.send(
            config.emailjs.serviceID,
            config.emailjs.templateID,
            templateParams
        );


        console.log('Newsletter subscription email sent successfully!');
        return true;
    } catch (error) {
        console.error('Failed to send newsletter email:', error);
        return false;
    }
};
